/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="25"
        height="23"
        viewBox="0 0 25 23"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M2.333.247.624 1.956l3.711 3.71h-2.71c-.667 0-1.208.542-1.208 1.209v7.25c0 .667.541 1.208 1.208 1.208h4.41c.274 0 .54.094.755.265l3.747 2.998c.791.633 1.963.07 1.963-.943v-3.821l8.63 8.63 1.71-1.709L2.332.247ZM9.076 3.572 12.5 6.996V3.347c0-1.013-1.172-1.576-1.963-.943l-1.46 1.168ZM17.188 11.684l1.883 1.883a7.223 7.223 0 0 0 .68-3.067 7.228 7.228 0 0 0-2.124-5.127l-.001.001a1.208 1.208 0 1 0-1.672 1.745 4.846 4.846 0 0 1 1.233 4.565ZM20.86 15.356l1.756 1.756a12.027 12.027 0 0 0 1.968-6.612c0-3.337-1.353-6.358-3.54-8.544a1.208 1.208 0 1 0-1.672 1.745 9.636 9.636 0 0 1 2.795 6.799c0 1.77-.476 3.43-1.307 4.856Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'AudioMutedIcon';

export default Icon;
